import {OrderContext} from "../../context/OrderContext";
import React, {useContext, useState, useEffect} from "react";
import {APIGetUser} from "../../api/user/User";
import {APIGetCompanyData} from "../../api/companies/Companies";
import { LuUser, LuUserCheck } from "react-icons/lu";

export default function OrderContactPerson() {

    const {order} = useContext(OrderContext);
    const [orderUser, setOrderUser] = useState(null);
    const [orderCompany, setOrderCompany] = useState(null);


    useEffect(() => {
        APIGetCompanyData(order?.createdByCompany).then(function(result) {
            setOrderCompany(result);
        });
        APIGetUser(order?.createdByUser).then(function(result) {
            setOrderUser(result);
        });
    }, [order?.createdByCompany, order?.createdByUser]);

    return (
        <div className={""}>
            <div className={""}>
                <div className="px-4 sm:px-0 mb-4">
                    <h3 className="text-lg font-bold text-gray-900">Auftraggeber</h3>
                </div>
                <div>
                    <ul className="grid ">

                        <li key={orderUser?.name} className="col-span-1 ">
                            <div className="flex w-full justify-between space-x-6 p-2">
                                <span className="inline-block size-10 overflow-hidden rounded-full p-2.5 bg-gray-300">
                                    <LuUserCheck className={"text-gray-600 w-5 h-5 "}/>
                                </span>
                                <div className="flex-1 truncate">
                                    <div className="flex items-center space-x-3">
                                        <h3 className="truncate text-sm font-medium text-gray-900">{orderUser?.name}</h3>
                                    </div>
                                    <p className="mt-1 truncate text-sm text-gray-600/60">{orderCompany?.name}</p>
                                    {(typeof orderUser?.details?.phone  !== "undefined" && orderUser?.details?.phone !== " ") ? (<a href={"tel:"+orderUser?.details?.phone} className="mt-1 block truncate text-sm text-gray-600/60">Tel: {orderUser?.details?.phone}</a>) : ("")}
                                    {(typeof orderUser?.email  !== "undefined" && orderUser?.email !== " ") ? (<a href={"mailto:"+orderUser?.email} className="mt-1 block truncate text-sm text-gray-600/60">{orderUser?.email}</a>) : ("")}
                                </div>
                            </div>
                        </li>
                    </ul>


                </div>
            </div>
            {(typeof order?.planDetails?.communicationPartner !== "undefined" && order?.planDetails?.communicationPartner?.length > 0) && (
                <div>
                    <div className="px-4 sm:px-0 mb-4 mt-6">
                        <h3 className="text-base/7 font-semibold text-gray-900">Weitere Ansprechpartner</h3>
                    </div>
                    <div>
                        <ul className="grid ">
                            {order?.planDetails.communicationPartner?.map((person) => {
                                return(
                                    <li key={person.email} className="col-span-1 ">
                                        <div className="flex w-full justify-between space-x-6 p-2">
                                            <span className="inline-block size-10 overflow-hidden rounded-full p-2.5 bg-gray-300">
                                                <LuUser className={"text-gray-600 w-5 h-5 "}/>
                                            </span>
                                            <div className="flex-1 truncate">
                                                <div className="flex items-center space-x-3">
                                                    <h3 className="truncate text-sm font-medium text-gray-900">{person?.name}</h3>
                                                </div>
                                                <p className="mt-1 truncate text-sm text-gray-600/60">{person?.department}</p>
                                                <p className="mt-1 truncate text-sm text-gray-600/60">Tel: {person?.phone}</p>
                                                <p className="mt-1 truncate text-sm text-gray-600/60">{person?.email}</p>
                                            </div>

                                        </div>
                                    </li>
                                )}
                            )}
                        </ul>


                    </div>
                </div>
            )}

        </div>







    );

}